import { Component, Input, EventEmitter, Output } from '@angular/core';
import {PagingModel} from '../models/paging-model';

@Component({
  selector: 'paging-header',
  template: `<div class="row">
      <div class="col-md-8">
          <div *ngIf="totalPages > 1">page {{pageNumber}} / {{totalPages}}</div>
          
      </div>
      <div class="col-md-4">
          <select *ngIf="totalPages > 1" 
                  class="form-control-sm" 
                  [ngModel]="itemsPerPage" 
                  (change)="changePerPage($event.target.value)">
              <option value="25">25 per page</option>
              <option value="50">50 per page</option>
              <option value="100">100 per page</option>
          </select>
      </div>
  </div>
  `
})
export class PagingHeaderComponent {

  @Input() public paging: PagingModel;
  @Output() public countChanged: EventEmitter<PagingModel> = new EventEmitter();

  get totalPages () {
    return this.paging.totalPages;
  }

  get pageNumber () {
    return this.paging.pageNumber;
  }

  get itemsPerPage () {
    return this.paging.itemsPerPage;
  }

  get totalItems () {
    return this.paging.totalItems;
  }

  public changePerPage(itemsPerPage: number) {
    const newPaging = Object.assign({}, this.paging);
    newPaging.itemsPerPage = itemsPerPage;
    this.countChanged.emit(newPaging);
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/paging-header.ts